const modelTypes = [{
  key: 'printReady',
  label: '3D Print',
}, {
  key: 'pbr',
  label: 'PBR',
}, {
  key: 'animated',
  label: 'Animated',
}, {
  key: 'rigged',
  label: 'Rigged',
}, {
  key: 'lowPoly',
  label: 'Low poly',
}]

export default modelTypes
